var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrawer9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "#656565",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.25C13.5858 0.25 13.25 0.585786 13.25 1V4.75H17.75V1C17.75 0.585786 17.4142 0.25 17 0.25H14ZM14.75 3.25V1.75H16.25V3.25H14.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.5C0.25 6.08579 0.585786 5.75 1 5.75H19C19.4142 5.75 19.75 6.08579 19.75 6.5C19.75 6.91421 19.4142 7.25 19 7.25H1C0.585786 7.25 0.25 6.91421 0.25 6.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 17C0.25 16.5858 0.585786 16.25 1 16.25H19C19.4142 16.25 19.75 16.5858 19.75 17C19.75 17.4142 19.4142 17.75 19 17.75H1C0.585786 17.75 0.25 17.4142 0.25 17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.75C2.58579 9.75 2.25 10.0858 2.25 10.5V15.25H12.25V10.5C12.25 10.0858 11.9142 9.75 11.5 9.75H3ZM3.75 13.75V11.25H10.75V13.75H3.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 10.5C13.25 10.0858 13.5858 9.75 14 9.75H17C17.4142 9.75 17.75 10.0858 17.75 10.5V15.25H13.25V10.5ZM14.75 11.25V13.75H16.25V11.25H14.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 1C7.75 0.585786 8.08579 0.25 8.5 0.25H11.5C11.9142 0.25 12.25 0.585786 12.25 1V4.75H7.75V1ZM9.25 1.75V3.25H10.75V1.75H9.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.25C2.58579 0.25 2.25 0.585786 2.25 1V4.75H6.75V1C6.75 0.585786 6.41421 0.25 6 0.25H3ZM3.75 3.25V1.75H5.25V3.25H3.75Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawer9);
export default __webpack_public_path__ + "static/media/drawer-9.1fe71e13726a5d0573184f98bf59f607.svg";
export { ForwardRef as ReactComponent };